The output of the `closePostedPositionProfile` mutation.
